module.exports = __webpack_public_path__ + "img/f1.f7770f42.png";